import React, { isValidElement } from "react";
import { Rating, Stack, Typography, Box } from "@mui/material";
import { ColletteChip } from "@collette-travel/collette-common-controls";
import { HeaderValueProps } from "./types";

const KeyTourInfoValue = ({ value,  detailId, orientation }: HeaderValueProps) => {
  if (typeof value === "string") {
    return (
      <Typography
        sx={{
          fontSize: "1.8rem",
          textAlign: orientation === "row" ? "start" : "end"
        }}
        data-testid={`header-${detailId}-value`}
      >
        {value}
      </Typography>
    );
  }

  if (isValidElement(value)) {
    return value;
  }

  if (value && typeof value === "object" && "avgNum" in value) {
    return (
      <Typography
        sx={{
          fontSize: "1.8rem",
          textAlign: orientation === "row" ? "start" : "end",
          textWrap: "balance"
        }}
        data-testid={`header-${detailId}`}
      >
        <span style={{ fontSize: "1.4rem" }}>{value.avgTranslation}</span> {value.avgNum}{" "}
        <span style={{ fontSize: "1.4rem" }}>{value.travelersTranslation}</span>
      </Typography>
    );
  }

  if (value && typeof value === "object" && "starRating" in value) {
    return (
      <Stack direction="row" gap="0.8rem" alignItems="center">
        <Rating
          size="small"
          value={value.starRating}
          readOnly
          data-testid={`header-${detailId}-rating`}
        />
        <Typography data-testid={`reviews-${detailId}-count`}>
          {`(${value.totalReviews})`}
        </Typography>
      </Stack>
    );
  }

  if (value && typeof value === "object" && "price" in value) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-end", sm: "center" },
          justifyContent: { xs: "center", sm: "normal" },
          gap: "8px",
          alignSelf: "stretch"
        }}
      >
        <Typography
          sx={{
            fontSize: "1.8rem",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "150%",
            whiteSpace: "nowrap"
          }}
          data-testid={`header-${detailId}-price`}
        >
          {value.price}
        </Typography>

        {value.crossedOutPrice && (
          <Typography
            sx={{
              color: "text.disabled",
              fontSize: "1.8rem",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "150%",
              textDecoration: "line-through",
              whiteSpace: { xs: "normal", md: "nowrap" },
               "&::after": { content: "\"*\"", ariaHidden: "true" }
            }}
            data-testid={`header-${detailId}-crossed-price`}
          >
            {value.crossedOutPrice}
          </Typography>
        )}
        {value.offer && (
          <ColletteChip
            color="warning"
            sx={{
              borderRadius: "1rem",
              fontWeight: 600,
              fontSize: "1.2rem"
            }}
            testId={`header-${detailId}-offer`}
            label={value.offer}
          />
        )}
      </Box>
    );
  }

  return null;
};

export default KeyTourInfoValue;
